export default __webpack_public_path__ + "static/media/SAS Alert Tone 3.8d3625e0.mp3";